import CompanyClientsCollections from './CompanyClientsCollections';

export default CompanyClientsCollections;
